<template>
  <div>
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col 
                cols="12" sm="9"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      small
                      exact
                      class="mr-4"
                      color="primary"
                      v-bind="attrs" 
                      v-on="on" 
                      @click="regresar"
                    >
                      <v-icon>
                        mdi-arrow-left
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Regresar</span>
                </v-tooltip>
                Gestionar Cupos - {{competencia.competencia}}
              </v-col>

            
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  label="Buscar Cupo"
                  v-model="searchTable"
                >
                </v-text-field>
              </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable"
          :items="saberes"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="detalles(item.id_cupo)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="gestionarParticipante(item.saber_id,item.id_cupo )"
                >
                  mdi-account-group
                </v-icon>
              </template>
              <span>Gestionar participantes</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    headersTable: [
      {
        text: "Saber",
        value: "saber",
        align: "start",
        width: "50%",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Cupos",
        value: "numero_participantes",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],
    centro_formacion_id: 0,
  }),

  mounted() {

    this.$store.dispatch("gestionarCuposCampesena",  this.$route.params.idCompetencia);
    this.$store.dispatch("crearCentrosFormacion");
    this.$store.dispatch(
      "obtenerCompetenciaCampesenaId",
      this.$route.params.idCompetencia
    );
    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    competencia() {
      return this.$store.getters.obtenerCompetenciaCampesena;
    },
    usuario() {
      return this.$store.getters.usuario;
    },

    saberes() {
      return this.$store.getters.obtenerCuposCentroFormacionCampesena(this.usuario.centro_formacion_id)
    },
    
  },

  methods: {
    detalles(cupo) {
      this.$router.push({
        name: "campesena-competencia-cupo-detalle",
        params: { idCupo: cupo },
      });
    },
    gestionarParticipante(saberId) {
      this.$router.push({
        name: "campesena-competencia-participantes",
        params: {
          idSaber: saberId,
          idCompetencia: this.$route.params.idCompetencia,
        },
      });
    },
  regresar() {
    this.$router.back();
  },
},
};
</script>
